module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAABI0lEQVQ4EWNkwA1YgFIuQGwOxFxAfB+ItwDxEyAmGugCVZ4D4v9o+AeQXwHEzEBMEFgBVfwEYpAht4F4MhDXAfFGIP4LxCDx1UCMF4C8cAuIQYqnATE7ECMDkCWvgRgkH40sgc7Ohio6BaRxOT8UquYhumZkPsjJINtABuICTECJT0AMUqcEUwQSRAbiUM5VZEE09j8g/zpUDKaeAd0gGP83mmZ0Lkwepp4BlFZAACQQB8SKIA4QFABxOJiFnVCCCicC6WdAfB+mrBrIAPmZHPwcqI8bZtABMg2BWWwO8yPMizCDSaVZYAaRqhFD/ahBGEGCIUD1MAIVWJQAuP5UoCmwxEUqfQ2ol40RyRk2QLYBECOLIUljZYKKkw1A/BGrLDmCAOdMWmS9MnYfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/wifi_encrypted@2x.png
// module id = 485
// module chunks = 1